<template>
  <el-dialog
    :title="dialogTitle"
    :close-on-click-modal="false"
    :visible.sync="dialogFormVisible"
    class="add-modal"
  >
    <el-form
      :model="form"
      ref="formRef"
      :rules="rules"
      label-width="100px"
      v-if="dialogFormVisible"
    >
      <el-form-item label="题型" prop="questionType">
        <el-select
          v-model="form.questionType"
          placeholder="请选择题型"
          @change="questionTypeChange"
          :disabled="dialogType == 'edit'"
        >
          <el-option label="单选" value="1"></el-option>
          <el-option label="多选" value="3"></el-option>
          <el-option label="判断" value="2"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="题干" prop="questionStem">
        <el-input
          v-model.trim="form.questionStem"
          type="textarea"
          :autosize="{ minRows: 10, maxRows: 16 }"
          maxlength="300"
          show-word-limit
          placeholder="请输入题干内容"
        ></el-input>
      </el-form-item>
      <el-form-item label="选项">
        <el-form-item
          label-width="160px"
          style="margin-bottom: 24px ;"
          v-for="(item, index) in form.list"
          :key="index"
          :label="'副标题：' + item.answerFLag + ' 选项内容'"
          :prop="`list.${index}.answerStem`"
          :rules="questionOptionRules"
        >
          <el-input
            style="width: 200px;"
            v-model.trim="item.answerStem"
            placeholder="请输入选项"
            :disabled="form.questionType === '2'"
          />
          <el-button
            style="margin-left: 8px;"
            type="primary"
            @click="addLine(index)"
            v-if="index === form.list.length - 1 && form.questionType == '3'"
            circle
            size="mini"
            icon="el-icon-plus"
          >
          </el-button>
          <el-button
            style="margin-left: 8px;"
            type="danger"
            @click="cutLine(index)"
            icon="el-icon-minus"
            size="mini"
            v-if="form.list.length > 4 && form.questionType == '3'"
            circle
          >
          </el-button>
        </el-form-item>
      </el-form-item>
      <el-form-item
        label="答案："
        prop="questionAnswer"
        v-if="form.questionType == '3'"
      >
        <el-checkbox-group v-model="form.questionAnswer">
          <el-checkbox
            :label="item.answerFLag"
            name="type"
            v-for="(item, index) in form.list"
            :key="index"
          ></el-checkbox>
        </el-checkbox-group>
      </el-form-item>
      <el-form-item label="答案：" prop="questionAnswer" v-else>
        <el-radio-group v-model="form.questionAnswer">
          <el-radio
            :label="item.answerFLag"
            v-for="(item, key) in form.list"
            :key="key"
            >{{ item.answerFLag }}</el-radio
          >
        </el-radio-group>
      </el-form-item>
      <el-form-item
        label="难度等级"
        prop="courseLevel"
        placeholder="请选择难度等级"
      >
        <el-select v-model="form.courseLevel" placeholder="请选择难度等级">
          <el-option label="初级" :value="1"></el-option>
          <el-option label="中级" :value="2"></el-option>
          <el-option label="高级" :value="3"></el-option>
        </el-select>
      </el-form-item>
    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible = false">关闭</el-button>
      <el-button type="primary" @click="submit()">提交</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { getQuestionBankDetail, editQuestion, addQuestion } from "@/api/manage";
export default {
  name: "TheoryBankForm",
  data() {
    const checkQuestionOption = (rule, value, callback) => {
      console.log(rule, value, callback);
      let res = 0;
      this.form.list.forEach(item => {
        if (item.answerStem == value) {
          res += 1;
        }
      });
      if (res > 1) {
        callback(new Error("该选项已存在"));
      }
      callback();
    };
    return {
      i: 0,
      dialogTitle: "新增",
      dialogType: "create",
      dialogFormVisible: false,
      form: {
        questionType: "1",
        questionStem: null,
        list: [],
        questionAnswer: null,
        courseLevel: null
      },
      questionOptionRules: [
        {
          required: true,
          message: "内容不能为空",
          trigger: "blur"
        },
        {
          required: true,
          validator: checkQuestionOption,
          trigger: ["blur", "change"]
        }
      ],

      rules: {
        region: [{ required: true, message: "请选择题型", trigger: "blur" }],
        questionStem: [
          { required: true, message: "请输入题干", trigger: "blur" }
        ],
        questionAnswer: [
          { required: true, message: "请选择答案", trigger: ["blur", "change"] }
        ],
        courseLevel: [
          {
            required: true,
            message: "请选择难度等级",
            trigger: ["blur", "change"]
          }
        ]
      }
    };
  },
  methods: {
    questionTypeChange(val) {
      this.form.questionAnswer = val == "3" ? [] : null;
      if (val == "2") {
        // 判断
        this.form.list = [
          {
            answerStem: "正确",
            answerFLag: "A"
          },
          {
            answerStem: "错误",
            answerFLag: "B"
          }
        ];
      } else {
        // 多选
        this.form.list = [
          {
            answerFLag: "A",
            answerStem: null
          },
          {
            answerFLag: "B",
            answerStem: null
          },
          {
            answerFLag: "C",
            answerStem: null
          },
          {
            answerFLag: "D",
            answerStem: null
          }
        ];
      }
    },
    async open(type, id = null) {
      this.dialogTitle = type == "create" ? "新增" : "编辑";
      this.dialogType = type;
      this.dialogFormVisible = true;
      if (type == "edit") {
        const res = await getQuestionBankDetail(id);
        if (res.data.code === 200) {
          if (this.$refs.modelFormRef) this.$refs.modelFormRef.resetFields();
          this.form = res.data.data;
          this.form.questionAnswer =
            this.form.questionType == "3"
              ? this.form.questionAnswer.split(",")
              : this.form.questionAnswer;
        }
      } else {
        this.form = {
          questionType: "1",
          questionStem: null,
          list: [],
          questionAnswer: null,
          courseLevel: null
        };
        this.questionTypeChange("1");
        console.log(this.form);
      }
      this.$nextTick(() => {
        this.$refs.formRef.clearValidate();
      });
    },
    setDesc(index = 69) {
      const letterArr = [];
      // 字母A的code值是65，但因为已经到字母D了，所以直接从69E开始循环
      for (let i = index; i < 91; i++) {
        letterArr[i] = String.fromCharCode(i);
      }
      return letterArr;
    },
    addLine(index) {
      if (index > 8) {
        this.$message({
          type: "warn",
          message: "最多只能添加10个选项"
        });
        return;
      }
      const randomAbc = this.setDesc().splice(69);
      const res = [
        ...this.form.list,
        {
          answerFLag: randomAbc[this.i],
          answerStem: null
        }
      ];
      this.i++;
      this.form.list = res;
    },
    cutLine(index) {
      const randomAbc = this.setDesc(65).splice(65);
      this.form.list.splice(index, 1);
      this.form.list = this.form.list.map((item, key) => {
        return {
          answerFLag: randomAbc[key],
          answerStem: item.answerStem
        };
      });
      this.i--;
    },
    async submit() {
      let valid = await this.$refs.formRef.validate();
      if (!valid) {
        return;
      }

      const formData = JSON.parse(JSON.stringify(this.form));
      formData.questionAnswer =
        formData.questionType == "3"
          ? formData.questionAnswer.join(",")
          : formData.questionAnswer;
      this.form = formData;
      if (this.dialogType == "create") {
        await addQuestion(formData);
        this.$emit("success");
      } else {
        await editQuestion(formData);
        this.$emit("success");
      }
      this.dialogFormVisible = false;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/views/Bank/TheoryBank/TheoryBankForm.vue